import {
  ChevronDoubleLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";
import { Button } from "../catalyst/button";

const segmentIconClasses = "sm:px-2 sm:py-2 sm:*:data-[slot=icon]:size-5";

export default function Pagination({
  page,
  handlePageChange,
  hasNextPage,
}: {
  page: number;
  handlePageChange: (page: number) => void;
  hasNextPage: boolean;
}) {
  return (
    <>
      {/* Pagination */}
      <div className="flex items-center justify-between bg-white dark:bg-zinc-800 py-4 dark:border-zinc-700">
        <div className="flex flex-1 justify-between sm:hidden">
          <Button
            outline
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 1}
          >
            Previous
          </Button>
          <Button
            outline
            className="ml-3"
            onClick={() => handlePageChange(page + 1)}
            disabled={!hasNextPage}
          >
            Next
          </Button>
        </div>
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
          <nav
            className="isolate inline-flex -space-x-px rounded-md shadow-sm"
            aria-label="Pagination"
          >
            <Button
              outline
              onClick={() => handlePageChange(1)}
              disabled={page === 1}
              buttonClassName={`rounded-r-none ${segmentIconClasses}`}
            >
              <span className="sr-only">First</span>
              <ChevronDoubleLeftIcon aria-hidden="true" />
            </Button>
            <Button
              outline
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
              buttonClassName={`rounded-none ${segmentIconClasses}`}
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon aria-hidden="true" />
            </Button>

            <p className="text-sm text-gray-700 dark:text-zinc-100 flex items-center px-5 ring-1 ring-inset ring-gray-300 dark:ring-zinc-700">
              <span>
                Showing page <span className="font-medium">{page}</span>
              </span>
            </p>
            <Button
              outline
              onClick={() => handlePageChange(page + 1)}
              disabled={!hasNextPage}
              buttonClassName={`rounded-l-none ${segmentIconClasses}`}
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon aria-hidden="true" />
            </Button>
          </nav>
        </div>
      </div>
    </>
  );
}
